<template>
  <v-snackbars
    :objects.sync="messages"
    :timeout="timeout"
    rounded="lg"
    transition="fade-transition"
  >
    <template v-slot:action="{ close, message, index }">
      <v-btn mini icon @click="onClose(close, message, index)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
    <template v-slot:default="{ message }">
      <v-layout
        align-center
        pr-4
        @click="click(message.onClick)"
        :class="{'snackbar-pointer': message.onClick ? true : false}"
      >
        <v-icon  dark large v-if="message.icon">{{ message.icon }}</v-icon>
        <v-layout column>
          <div style="text-align: center;">
            <strong>{{ message.title }}</strong>
          </div>
          <div style="text-align: center;">{{ message.body }}</div>
        </v-layout>
      </v-layout>
    </template>
  </v-snackbars>
</template>

<script>
import VSnackbars from 'v-snackbars'

export default {
  name: 'Snackbar',
  components: {
    'v-snackbars': VSnackbars
  },
  props: {
    bottom: Boolean,
    center: Boolean,
    right: Boolean,
    left: Boolean
  },
  data() {
    return {
      timeout: 10000,
      messages: [],
      timeouts: {}
    }
  },
  methods: {
    addMessage(item) {
      item.message.id = new Date().toISOString
      this.messages.push(item);
      const message = item.message
      if (message.onShown) {
        message.onShown()
      }
      if (message.onClose) {
        this.timeouts[message.id] = setTimeout(() => {
          window.clearTimeout(this.timeouts[message.id])
          message.onClose()
        }, item.timeout || this.timeout)
      }
    },
    onClose(close, message) {
      if (message.onClose) {
        window.clearTimeout(this.timeouts[message.id])
        message.onClose()
      }
      close()
    },
    click(fn) {
      if (fn) {
        fn()
      }
    },
  }
}
</script>

<style lang="scss">
  /* Snackbar global Kalan: estética limpia tipo "banner" — sin ridge
     (que se veía bisel feo), border-radius cómodo, sombra profunda,
     contraste alto. Se posiciona debajo del topbar para no taparse
     con la barra de navegación cuando aparece top-center. */
  .v-snack__wrapper {
    opacity: 1 !important;
    border-radius: 8px !important;
    border: none !important;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.06) inset !important;
    min-height: 44px !important;
    padding: 6px 12px !important;
  }

  /* Top placement: respeta el topbar (~52px). Sin esto los snackbars
     "top" quedan pegados arriba de todo y tapan la barra de búsqueda. */
  .v-snack--top .v-snack__wrapper {
    margin-top: 56px !important;
  }

  .v-snack__content {
    padding: 6px 8px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    letter-spacing: 0.01em !important;
  }

  .snackbar-pointer {
    cursor: pointer;
  }

  .v-snack__action {
    align-self: center !important;
    margin-right: unset !important;
  }
</style>
